import { DesktopNavigation, MobileNavigation } from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import ContactPage from "./pages/ContactPage";
import TreatmentsPage from "./pages/TreatmentsPage";
import MentalHealthCarePage from "./pages/MentalHealthCarePage";
import BookNowPage from "./pages/BookNowPage";
import BlogPage from "./pages/BlogPage";
import LandingPage from "./pages/LandingPage";
import KeepingYouSafePage from "./pages/KeepingYouSafePage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import TeamsPage from "./pages/TeamsPage";
import TeamMemberPage from "./pages/TeamMemberPage";
import FeesPage from "./pages/FeesPage";
import HowToPayPage from "./pages/HowToPayPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ExternalLinksPage from "./pages/ExternalLinksPage";
import GiftVouchersPage from "./pages/GiftVouchersPage";
import IssuesWeSolvePage from "./pages/IssuesWeSolvePage";
import YouthMentoringPage from "./pages/YouthMentoringPage";
import ChildrenMentoringPage from "./pages/ChildrenMentoringPage";
import FinancialWellbeingPage from "./pages/FinancialWellbeingPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import ReferencePage from "./pages/ReferencePage";
import PsychiatryPage from "./pages/PsychiatryPage";
import SupervisionPage from "./pages/SupervisionPage";
import MentalHealthCareUKPage from "./pages/MentalHealthCareUKPage";
import CoachingStaffWellbeingPage from "./pages/CoachingStaffWellbeingPage";
import PaidAssessmentPage from "./pages/PaidAssessmentPage";
import FreeAssessmentPage from "./pages/FreeAssessmentPage";
import './App.css';
import CBTServicesPage from "./pages/CBTServicesPage";
import EAPPage from "./pages/EAPPage";
import CounselingPage from "./pages/CounselingPage";
import CouplesTherapyPage from "./pages/CouplesTherapyPage";
import ClinicalPsychologyPage from "./pages/ClinicalPsychologyPage";
import NewHopeService from "./pages/NewHopeService";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/*" element={
          <div className="min-h-screen bg-gray-50">
            <DesktopNavigation />
            <MobileNavigation />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/landing" element={<LandingPage />} />
              <Route path="/gateway" element={<LandingPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/book-now" element={<BookNowPage />} />
              <Route path="/book" element={<BookNowPage />} />
              <Route path="/booking" element={<BookNowPage />} />
              <Route path="/treatments" element={<TreatmentsPage />} />
              {/* Restore individual treatment pages */}
              <Route path="/approaches-we-use" element={<TreatmentsPage />} />
              <Route path="/cbt" element={<CBTServicesPage />} />
              <Route path="/treatments/cbt" element={<CBTServicesPage />} />
              <Route path="/eap" element={<EAPPage />} />
              <Route path="/treatments/eap" element={<EAPPage />} />
              <Route path="/counseling" element={<CounselingPage />} />
              <Route path="/treatments/counseling" element={<CounselingPage />} />
              <Route path="/clinical-therapy" element={<ClinicalPsychologyPage />} />
              <Route path="/treatments/clinical-therapy" element={<ClinicalPsychologyPage />} />
              <Route path="/couples-therapy" element={<CouplesTherapyPage />} />
              <Route path="/treatments/couples-therapy" element={<CouplesTherapyPage />} />
              <Route path="/approaches" element={<TreatmentsPage />} />
              <Route path="/issues-we-solve" element={<IssuesWeSolvePage />} />
              <Route path="/mental-health-care" element={<MentalHealthCarePage />} />
              <Route path="/keeping-you-safe" element={<KeepingYouSafePage />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
              <Route path="/teams" element={<TeamsPage />} />
              <Route path="/team/:id" element={<TeamMemberPage />} />
              <Route path="/fees" element={<FeesPage />} />
              <Route path="/how-to-pay" element={<HowToPayPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/external-links" element={<ExternalLinksPage />} />
              <Route path="/gift-vouchers" element={<GiftVouchersPage />} />
              <Route path="/issues-we-solve" element={<IssuesWeSolvePage />} />
              <Route path="/youth-mentoring" element={<YouthMentoringPage />} />
              <Route path="/children-mentoring" element={<ChildrenMentoringPage />} />
              <Route path="/financial-wellbeing" element={<FinancialWellbeingPage />} />
              <Route path="/disclaimer" element={<DisclaimerPage />} />
              <Route path="/references" element={<ReferencePage />} />
              <Route path="/psychiatry" element={<PsychiatryPage />} />
              <Route path="/psychiatry-diagnostics" element={<PsychiatryPage />} />
              <Route path="/supervision" element={<SupervisionPage />} />
              <Route path="/supervision/clinical" element={<SupervisionPage />} />
              <Route path="/mental-health-care-uk" element={<MentalHealthCareUKPage />} />
              <Route path="/what-is-mental-health-care" element={<MentalHealthCareUKPage />} />
              <Route path="/coaching-staff-wellbeing" element={<CoachingStaffWellbeingPage />} />
              <Route path="/coaching-wellbeing" element={<CoachingStaffWellbeingPage />} />
              <Route path="/assessments/paid" element={<PaidAssessmentPage />} />
              <Route path="/paid-assessment" element={<PaidAssessmentPage />} />
              <Route path="/assessments/free" element={<FreeAssessmentPage />} />
              <Route path="/free-assessment" element={<FreeAssessmentPage />} />
              <Route path="/twin-brain/assessments" element={<PaidAssessmentPage />} />
              <Route path="/webinars/upcoming" element={<div className="p-8"><h1 className="text-2xl">Upcoming Webinars - Coming Soon</h1></div>} />
              <Route path="/book/appointment" element={<BookNowPage />} />
              <Route path="/new-hope-service" element={<NewHopeService />} />
              <Route path="/blog" element={<BlogPage />} />
            </Routes>
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
